<template>
  <v-app>
    <v-navigation-drawer persistent v-model="drawer" enable-resize-watcher app :mini-variant.sync="miniVariant">
      <v-toolbar flat class="transparent">
        <v-list>
          <v-list-tile avatar tag="div" v-if="currentUser.userId">
            <v-list-tile-avatar>
              <img :src="currentUser.avatar" />
            </v-list-tile-avatar>
            <v-list-tile-content v-if="currentUser.userId">
              <v-list-tile-title>{{ currentUser.fullname }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ currentUser.email }}</v-list-tile-sub-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn icon @click.native.stop="miniVariant = !miniVariant">
                <v-icon>chevron_left</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>

          <v-list-tile v-else ripple>
            <v-list-tile-action>
              <v-icon>account_circle</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Nicht angemeldet</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-toolbar>
      <v-list class="pt-0">
        <v-divider></v-divider>
        <v-list-tile v-for="item in drawerItems" :key="item.title" :to="item.link" ripple>
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-group v-for="item in drawerTools" :value="item.active" :key="item.title">
          <v-list-tile slot="item" @click="">
            <v-list-tile-action>
              <v-icon>{{ item.action }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>keyboard_arrow_down</v-icon>
            </v-list-tile-action>
          </v-list-tile>
          <v-list-tile v-for="subItem in item.items" :key="subItem.title" :to="subItem.link + currentDataset.meta.id">
            <v-list-tile-content>
              <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-icon>{{ subItem.action }}</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
        <v-list-tile @click.stop="sheet = true" ripple :disabled="!currentDataset.meta.id" v-if="isReferatsleitung">
          <v-list-tile-action>
            <v-icon>assignment_turned_in</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Zur Veröffentlichung freigeben</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="logoutUser">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Abmelden</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile ripple>
        <v-list-tile @click.stop="miniVariant = !miniVariant">
          <v-list-tile-action>
            <v-icon class="grey--text">{{ miniVariant ? 'chevron_right' : 'chevron_left' }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title class="grey--text">Menü minimieren</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list style="width: 50%; position: absolute; bottom: 160px;" class="ma-4">
        <a href="/datenschutzbestimmungen" target="_blank">Datenschutz</a><br>
        <a href="/impressum">Impressum</a><br>
        <a href="/kontakt">Kontakt</a>
      </v-list>
      <img src="./assets/logo-rgb-web.jpg" style="width: 50%; position: absolute; bottom: 75px" class="ma-4">
      <img src="./assets/fokus_logo_farbig.png" style="width: 50%; position: absolute; bottom: 0" class="ma-4">
    </v-navigation-drawer>

    <router-view app></router-view>

    <footer-arrows></footer-arrows>

    <v-bottom-sheet v-model="sheet">
      <v-card tile>
        <v-card-title primary-title>
          <div>
            <h4 class="headline mb-0">Datensatz zur <b>Veröffentlichung</b> freigeben</h4>
            <div>Sind Sie sicher, dass Sie diesen Datensatz zur Veröffentlichung freigeben möchten?</div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-btn flat color="primary" @click="publishDataset" :loading="loadingIndicator">Freigeben</v-btn>
          <v-btn flat @click="sheet = false">Abbrechen</v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Der Datensatz wurde erfolgreich veröffentlicht.</v-card-title>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" flat="flat" @click.native="dialog = false">Schließen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import FooterArrows from '@/components/FooterArrows'

export default {
  computed: {
    currentUser () {
      return this.$store.getters.getCurrentUser
    },
    currentDataset () {
      return this.$store.getters.getCurrentDataset
    },
    isReferatsleitung () {
      return this.$store.getters.getIsReferatsleitung
    }
  },
  components: {
    FooterArrows
  },
  data () {
    return {
      drawer: true,
      drawerItems: [
        { icon: 'dashboard', title: 'Dashboard', link: '/dashboard' },
        { icon: 'settings', title: 'Einstellungen', link: '/settings' }
      ],
      drawerTools: [
        {
          action: 'work',
          title: 'Tools',
          active: true,
          items: [
            { title: 'Erfassung', link: '/erfassung/' },
            { title: 'Bewertung', link: '/bewertung/' },
            { title: 'Aufwertung', link: '/aufwertung/' },
            { title: 'Anonymisierung', link: '/anonymisierung/' }
          ]
        }
      ],
      miniVariant: false,
      sheet: false,
      dialog: false,
      loadingIndicator: false
    }
  },
  methods: {
    logoutUser () {
      this.$store.dispatch('logoutUser')
    },
    publishDataset () {
      this.loadingIndicator = true
      var that = this
      setTimeout(function () {
        that.currentDataset.meta.status.visibility = 'Veröffentlicht'
        that.loadingIndicator = false
        that.sheet = false
        that.dialog = true
      }, 1400)
    }
  }
}
</script>

<style lang="stylus">
@import './stylus/main'

.toolbar-no-dark {
  background-color: transparent !important
}

.loading-dataset-indicator {
  position: absolute;
  top: 50%;
  left: 50%;
  transform-origin-x: -50%;
  transform-origin-y: -50%;
}

footer
  .list__tile
    min-height: 100px;

    &__title
      color: #fff

    &__sub-title
      color: rgba(#fff, .3)
</style>



// WEBPACK FOOTER //
// src/App.vue